import {Injectable} from '@angular/core';
import {SecurityClaim} from '../models/security-claim.model';

@Injectable()
/**
 * Provides methods for storing and retrieving security information from the cache location
*/
export class SecurityCacheService {

    // COMMON security stamp
    public static get securityStampKey(): string {
        return 'mvd:ss';
    }
    public static get securityStamp(): string {
        return localStorage.getItem(SecurityCacheService.securityStampKey);
    }
    public static cacheSecurityStamp(securityStamp: string) {
        localStorage.setItem(SecurityCacheService.securityStampKey, securityStamp);
    }
    public static clearCacheSecurityStamp() {
        localStorage.removeItem(SecurityCacheService.securityStampKey);
    }

    // ACS claims
    public static get acsClaimsKey(): string {
        return 'mvd:acs';
    }

    public static get acsClaims(): SecurityClaim[] {
        return JSON.parse(localStorage.getItem(SecurityCacheService.acsClaimsKey));
    }

    public static cacheACSClaims(acsClaims: SecurityClaim[]) {
        localStorage.setItem(SecurityCacheService.acsClaimsKey, JSON.stringify(acsClaims));
    }

    public static clearCacheACSClaims() {
        localStorage.removeItem(SecurityCacheService.acsClaimsKey);
    }

    // Multiple Claim Sets
    public static get multipleClaimSetsKey(): string {
        return 'mvd:multiple';
    }

    public static get multipleClaimSets(): SecurityClaim[] {
        return JSON.parse(localStorage.getItem(SecurityCacheService.multipleClaimSetsKey));
    }

    public static cacheMultipleClaimSets(multipleClaimSets: SecurityClaim[]) {
        localStorage.setItem(SecurityCacheService.multipleClaimSetsKey, JSON.stringify(multipleClaimSets));
    }

    public static clearCacheMultipleClaimSets() {
        localStorage.removeItem(SecurityCacheService.multipleClaimSetsKey);
    }

    // security claims
    public static get securityClaimsKey(): string {
        return 'mvd:c';
    }
    public static get securityClaims(): SecurityClaim[] {
        return JSON.parse(localStorage.getItem(SecurityCacheService.securityClaimsKey));
    }
    public static cacheSecurityClaims(securityClaims: SecurityClaim[]) {
        localStorage.setItem(SecurityCacheService.securityClaimsKey, JSON.stringify(securityClaims));
    }
    public static clearCacheSecurityClaims() {
        localStorage.removeItem(SecurityCacheService.securityClaimsKey);
    }

    // business unit
    public static cacheBusinessUnit(businessUnitDescriptor: string) {
        localStorage.setItem(SecurityCacheService.businessUnitCookieName, businessUnitDescriptor);
    }

    // Window
    public static cacheWindow(windowId: string) {
        localStorage.setItem(SecurityCacheService.windowCookieName, windowId);
    }

    public static get businessUnit() {
        return localStorage.getItem(SecurityCacheService.businessUnitCookieName);
    }

    public static get window() {
        return localStorage.getItem(SecurityCacheService.windowCookieName);
    }

    public static get businessUnitId(): string {
        const value: string = SecurityCacheService.businessUnit;
        return value && value.indexOf(',') > 0 ? value.split(',')[0] : '';
    }
    public static get businessUnitName(): string {
        const value: string = SecurityCacheService.businessUnit;
        return value && value.indexOf(',') > 0 ? value.split(',')[1] : '';
    }
    public static get businessUnitTypeId(): string {
        const value: string = SecurityCacheService.businessUnit;
        return value && value.indexOf(',') > 0 ? value.split(',')[2] : '';
    }
    public static get businessUnitCookieName(): string {
        return 'mvd:bu';
    }
    public static get windowCookieName(): string {
        return 'mvd:windowId';
    }
}
